import React from 'react'
import BurgerSpanUi from 'common/components/entities/Menu/components/Mobile/Burger/ui/BurgerSpanUi'
import BurgerUi from 'common/components/entities/Menu/components/Mobile/Burger/ui/BurgerUi'
import BurgerWrapperUi from 'common/components/entities/Menu/components/Mobile/Burger/ui/BurgerWrapperUi'
import { AlignSelfType, PaddingType } from 'common/types/styleTypes'

type BurgerProps = {
  handleClick?: () => void
  burgerIconColor: string
  opened?: boolean
  openedColor: string
  forceVisible?: boolean
  fixed?: boolean
  padding: PaddingType
  mobilePadding: PaddingType
  burgerAlignSelf: AlignSelfType | undefined
}

function Burger({
  handleClick,
  burgerIconColor,
  opened = false,
  openedColor,
  forceVisible = false,
  fixed = false,
  padding,
  mobilePadding,
  burgerAlignSelf = 'flex-end',
}: BurgerProps) {
  return (
    <BurgerWrapperUi justifyContent={burgerAlignSelf}>
      <BurgerUi
        onClick={handleClick}
        opened={opened}
        forceVisible={forceVisible}
        fixed={fixed}
        padding={padding}
        mobilePadding={mobilePadding}
      >
        <BurgerSpanUi
          burgerIconColor={burgerIconColor}
          openedColor={openedColor}
          opened={opened}
        />
        <BurgerSpanUi
          burgerIconColor={burgerIconColor}
          openedColor={openedColor}
          opened={opened}
        />
        <BurgerSpanUi
          burgerIconColor={burgerIconColor}
          openedColor={openedColor}
          opened={opened}
        />
      </BurgerUi>
    </BurgerWrapperUi>
  )
}

export default Burger
